// This file is auto-generated by @hey-api/openapi-ts

/* eslint-disable */
import {
  type Options as ClientOptions,
  type TDataShape,
  type Client,
  formDataBodySerializer,
} from "@hey-api/client-fetch";
import type {
  AppControllerPingData,
  SharedControllerFindManyTypeData,
  SharedControllerFindManyCovenantDetailData,
  SharedControllerFindManyCovenantSecurityTypesData,
  AuthControllerLoginData,
  AuthControllerLoginResponse,
  AuthControllerRequestMfaData,
  AuthControllerRequestPinData,
  AuthControllerSendPinData,
  AuthControllerSignupData,
  AuthControllerNewSignupData,
  AuthControllerSignupDemoData,
  AuthControllerUpdateAccountData,
  AuthControllerActivateData,
  AuthControllerChangeRoleData,
  AuthControllerConfirmData,
  AuthControllerConfirmResponse,
  AuthControllerRefreshData,
  AuthControllerRefreshResponse,
  AuthControllerForgotData,
  AuthControllerForgotResponse,
  AuthControllerResetData,
  AuthControllerResetResponse,
  AuthControllerLogoutData,
  AuthControllerRequestContextData,
  ReviewControllerFindMyRequestsData,
  ReviewControllerFindMyRequestsResponse,
  ReviewControllerCreateData,
  ReviewControllerCreateResponse,
  ReviewControllerCancelRequestData,
  ReviewControllerFindByIdData,
  ReviewControllerUpdateData,
  ReviewControllerUpdateResponse,
  ReviewControllerCancelReviewData,
  ReviewControllerVoteData,
  ReviewControllerVoteResponse,
  ReviewControllerFindApprovalByTokenData,
  ReviewControllerVoteByTokenData,
  ReviewControllerVoteByTokenResponse,
  ReviewControllerFindMyChangesData,
  ReviewControllerApplyChangesData,
  ReviewControllerApplyChangesResponse,
  ReviewControllerFindApprovalByIdData,
  ReviewControllerFindAllByGrantedDealsData,
  ReviewControllerFindPendingReviewsData,
  ReviewControllerFindCurrentByDealData,
  ReviewControllerFindCurrentByDealResponse,
  ReviewControllerGetDealReviewHistoryData,
  EventControllerFindManyData,
  EventControllerFindManyResponse,
  EventControllerMergeData,
  EventControllerMergeResponse,
  EventControllerUpdateData,
  EventControllerUpdateResponse,
  EventControllerCompleteWithCorporateData,
  EventControllerCompleteWithCorporateResponse,
  EventControllerSendReminderData,
  CorporateCovenantControllerFindManyData,
  CorporateCovenantControllerFindManyResponse,
  CorporateCovenantControllerGetComplianceDocumentsData,
  CorporateCovenantControllerGetComplianceDocumentsResponse,
  CorporateCovenantControllerCreateValuesData,
  ComplianceDocumentControllerFindManyData,
  ComplianceDocumentControllerFindManyResponse,
  LoanControllerFindManyData,
  LoanControllerFindManyResponse,
  LoanControllerCreateData,
  LoanControllerCreateResponse,
  LoanControllerRemoveData,
  LoanControllerUpdateData,
  LoanControllerUpdateResponse,
  LoanControllerFindPortfolioDealsData,
  LoanControllerFindPortfolioDealsResponse,
  LoanControllerCreateTranchesData,
  LoanControllerCreateTranchesResponse,
  LoanControllerCreateBankingSyndicateData,
  LoanControllerCreateBankingSyndicateResponse,
  LoanControllerRemoveBankingSyndicateData,
  LoanControllerUpdateBankingSyndicateData,
  LoanControllerUpdateBankingSyndicateResponse,
  LoanControllerCreateMarginData,
  LoanControllerCreateMarginResponse,
  LoanControllerRemoveMarginData,
  LoanControllerUpdateMarginData,
  LoanControllerUpdateMarginResponse,
  LoanControllerCreateDrawdownData,
  LoanControllerCreateDrawdownResponse,
  LoanControllerDeleteDrawdownData,
  LoanControllerUpdateDrawdownData,
  LoanControllerUpdateDrawdownResponse,
  LoanControllerRemoveBulkDrawdownData,
  LoanControllerCreateBulkDrawdownData,
  LoanControllerCreateBulkDrawdownResponse,
  LoanControllerCreateRepaymentHeaderData,
  LoanControllerCreateRepaymentHeaderResponse,
  LoanControllerDeleteRepaymentHeaderData,
  LoanControllerUpdateRepaymentHeaderData,
  LoanControllerUpdateRepaymentHeaderResponse,
  LoanControllerCreateRepaymentScheduleData,
  LoanControllerCreateRepaymentScheduleResponse,
  LoanControllerRemoveBulkRepaymentData,
  LoanControllerCreateBulkRepaymentData,
  LoanControllerCreateBulkRepaymentResponse,
  LoanControllerDuplicateSecurityPackageData,
  LoanControllerDuplicateSecurityPackageResponse,
  LoanControllerCreateSecurityPackageData,
  LoanControllerCreateSecurityPackageResponse,
  LoanControllerRemoveSecurityPackageData,
  LoanControllerUpdateSecurityPackageData,
  LoanControllerUpdateSecurityPackageResponse,
  LoanMarginControllerUpsertCovenantData,
  LoanMarginControllerUpsertRatingData,
  LoanMarginControllerAddCovenantValueData,
  LoanMarginControllerUpdateCovenantValueData,
  LoanMarginControllerUpdateCovenantValueResponse,
  LoanMarginControllerAddRatingValueData,
  EventLogControllerGetEventLogsData,
  EventLogControllerGetEventLogsResponse,
  OrganizationControllerFindManyData,
  OrganizationControllerFindManyResponse,
  OrganizationControllerCreateData,
  OrganizationControllerCreateResponse,
  OrganizationControllerFindBorrowersData,
  OrganizationControllerFindBorrowersResponse,
  OrganizationControllerCreateRequestData,
  OrganizationControllerCreateRequestResponse,
  OrganizationControllerJoinData,
  OrganizationControllerCreateBulkData,
  OrganizationControllerCreateBulkResponse,
  OrganizationControllerDeleteThemeData,
  OrganizationControllerChangeThemeData,
  OrganizationControllerChangeThemeResponse,
  OrganizationControllerGetDocumentS3Data,
  OrganizationControllerAddRatingData,
  OrganizationControllerAddRatingResponse,
  DealControllerFindManyData,
  DealControllerFindManyResponse,
  DealControllerCreateData,
  DealControllerCreateResponse,
  DealControllerGetAiApiKeyData,
  DealControllerGetAiApiKeyResponse,
  DealControllerFindPortfolioDealsData,
  DealControllerFindPortfolioDealsResponse,
  DealControllerFindDocumentByDateData,
  DealControllerFindDocumentByDateResponse,
  DealControllerDeleteData,
  DealControllerDeleteResponse,
  DealControllerUpdateData,
  DealControllerUpdateResponse,
  DealControllerValidateData,
  DealControllerValidateResponse,
  DealControllerCreateAgentBankAccountData,
  DealControllerCreateAgentBankAccountResponse,
  DealControllerRemoveAgentAccountBankData,
  DealControllerUpdateAgentBankAccountData,
  DealControllerUpdateAgentBankAccountResponse,
  DealControllerFindManyDocumentData,
  DealControllerFindManyDocumentResponse,
  DealControllerCreateDocumentData,
  DealControllerUpdateSignedDocumentData,
  DealControllerUpdateSignedDocumentResponse,
  DealControllerGetDocumentPdfData,
  DealControllerGetDocumentS3Data,
  DealControllerRemoveDocumentData,
  DealControllerGetDocumentData,
  DealControllerUpdateDocumentData,
  DealControllerFindOnlyDealDocumentData,
  DealControllerFindOnlyDealDocumentResponse,
  DealControllerFindManyContactsData,
  DealControllerInviteData,
  DealControllerInviteResponse,
  DealControllerCreateBulkContactData,
  DealControllerCreateBulkContactResponse,
  DealControllerFindContactsData,
  DealControllerFindManyOrganizationsData,
  DealControllerFindManyOrganizationsResponse,
  DealControllerRemoveContactData,
  DealControllerUpdateContactData,
  DealControllerUpdateContactResponse,
  DealControllerDeleteMainContactData,
  DealControllerDeleteMainContactResponse,
  DealControllerUpdateMainContactData,
  DealControllerUpdateMainContactResponse,
  DealControllerFindManyMessageData,
  DealControllerCreateMessageData,
  DealControllerCreateMessageResponse,
  DealControllerReadMessageData,
  DealControllerReadMessageResponse,
  DealControllerFindCovenantValuesData,
  DealControllerFindCovenantValuesResponse,
  DealControllerGethashData,
  DealControllerGethashResponse,
  DealSecuritiesControllerFindData,
  DealSecuritiesControllerFindResponse,
  ParseDocumentsControllerCreateDocumentData,
  ParseDocumentsControllerCreateDocumentResponse,
  ParseDocumentsControllerGetDocumentS3Data,
  DocumentTreeControllerGetDocumentTreeData,
  DocumentTreeControllerGetDocumentTreeResponse,
  DocumentTreeControllerUpsertDocumentTreeData,
  TemplateControllerFindManyData,
  TemplateControllerCreateData,
  TemplateControllerFindTemplateByIdData,
  TemplateControllerUpdateData,
  TemplateControllerUpdateResponse,
  TemplateControllerFindTemplateData,
  CovenantControllerFindManyData,
  CovenantControllerFindManyResponse,
  CovenantControllerCreateData,
  CovenantControllerCreateResponse,
  CovenantControllerRemoveData,
  CovenantControllerRemoveResponse,
  CovenantControllerUpdateData,
  CovenantControllerUpdateResponse,
  CovenantControllerCreateThresholdData,
  CovenantControllerCreateThresholdResponse,
  CovenantControllerRemoveThresholdData,
  CovenantControllerRemoveThresholdResponse,
  CovenantControllerUpdateThresholdData,
  CovenantControllerUpdateThresholdResponse,
  CovenantControllerCreateValuesData,
  CovenantControllerCreateValuesResponse,
  CertificateControllerFindManyData,
  CertificateControllerFindManyResponse,
  CertificateControllerCreateData,
  CertificateControllerCreateResponse,
  CertificateControllerRemoveData,
  CertificateControllerRemoveResponse,
  CertificateControllerUpdateData,
  CertificateControllerUpdateResponse,
  CurrencyControllerFindManyData,
  CurrencyControllerFindManyResponse,
  CurrencyControllerCreateData,
  CurrencyControllerCreateResponse,
  UserControllerMeData,
  UserControllerMeResponse,
  UserControllerUpdateData,
  UserControllerUpdateResponse,
  UserControllerPortfolioData,
  UserControllerPortfolioResponse,
  UserControllerGetAccountsData,
  UserControllerGetAccountsResponse,
  UserControllerByTokenData,
  UserControllerByTokenResponse,
  UserControllerReadNotificationData,
  UserControllerReadNotificationResponse,
  UserControllerReadAllNotificationData,
  UserControllerReadAllNotificationResponse,
  UserControllerReadAlChatMessagesData,
  UserControllerReadAlChatMessagesResponse,
  UserControllerStatusUpdateData,
  UserControllerStatusUpdateResponse,
  UserControllerNotesData,
  UserControllerCreateNoteData,
  UserControllerCreateNoteResponse,
  UserControllerRemoveNoteData,
  UserControllerUpdateNoteData,
  UserControllerMyPreferencesData,
  UserControllerPreferencesData,
  UserControllerFindAclData,
  SseControllerMessagesData,
  SseControllerMessagesResponse,
  SseControllerNotificationsData,
  SseControllerNotificationsResponse,
  SseControllerConnectedContactsData,
  AssetControllerCreateAssetsData,
  AssetControllerCreateAssetValueData,
  AssetControllerCreateAssetEmploymentData,
  AssetControllerCreateAssetInsuranceData,
  AssetControllerCreateEsgValueData,
  AssetControllerDeleteAssetValueData,
  AssetControllerUpdateAssetValueData,
  AssetControllerUpdateAssetValueResponse,
  AssetControllerDeleteAssetEmploymentData,
  AssetControllerUpdateEmploymentValueData,
  AssetControllerUpdateEmploymentValueResponse,
  AssetControllerActivateEmploymentData,
  AssetControllerActivateEmploymentResponse,
  AssetControllerDeleteAssetInsuranceData,
  AssetControllerUpdateInsuranceValueData,
  AssetControllerUpdateInsuranceValueResponse,
  AssetControllerDeleteAssetData,
  AssetControllerGetAssetData,
  AssetControllerUpdateAssetData,
  AssetControllerUpdateAssetResponse,
  AssetControllerDeleteAssetEsgValueData,
  AssetControllerDeleteCiiForecastData,
  AssetControllerFindData,
  AssetControllerFindResponse,
  AssetControllerLoanAssetFindData,
  AssetControllerLoanAssetFindResponse,
  AssetControllerFindAssetValuesData,
  AssetControllerFindAssetValuesResponse,
  LeasingControllerDeleteAssetScheduleData,
  LeasingControllerDeleteAssetScheduleResponse,
  LeasingControllerFindAssetScheduleData,
  LeasingControllerCreateAssetScheduleData,
  LeasingControllerUpdateAssetScheduleData,
  LeasingControllerUpdateAssetScheduleResponse,
  LeasingControllerUpdateInstalmentData,
  LeasingControllerUpdateInstalmentResponse,
  LeasingControllerSendReminderData,
  CountryControllerGetCountryData,
  CountryControllerFindData,
  DocusignControllerCreateDocumentData,
  DocusignControllerCreateDocumentResponse,
  DocusignControllerPingData,
  DocusignControllerPingResponse,
  CorporateDocumentControllerFindTypesData,
  CorporateDocumentControllerFindTypesResponse,
  CorporateDocumentControllerCreateDocumentData,
  CorporateDocumentControllerCreateDocumentResponse,
  CorporateDocumentControllerDeleteDocumentData,
  CorporateDocumentControllerDeleteDocumentResponse,
  CorporateDocumentControllerUpdateDocumentData,
  CorporateDocumentControllerUpdateDocumentResponse,
  CorporateDocumentControllerGetDocumentS3Data,
  CorporateDocumentControllerGetCorporatesData,
  HealthControllerComputeOhDearSummaryData,
  HealthControllerComputeOhDearSummaryResponse,
  ExporterControllerComputeExportData,
  ExporterControllerComputeExportResponse,
  CiiControllerProccessData,
  CiiControllerFindData,
  CiiControllerFindResponse,
  CiiControllerSaveData,
  CiiControllerUpdateData,
  CiiControllerUpdateResponse,
  CiiControllerFindByAssetData,
  CiiControllerFindByAssetResponse,
  AccountControllerFindManyData,
  AccountControllerFindManyResponse,
  AccountControllerCreateData,
  AccountControllerCreateResponse,
  AccountControllerAddUserToaccountData,
  CashManagementControllerGetAllTradesByAccountData,
  CashManagementControllerGetAllTradesByAccountResponse,
  CashManagementControllerUpsertTradeData,
  CashManagementControllerUpsertTradeResponse,
  CashManagementControllerDeleteTradeData,
  CashManagementControllerUpdateTradeData,
  CashManagementControllerUpdateTradeResponse,
  CashManagementControllerFindSimlationsByAccountData,
  CashManagementControllerFindSimlationsByAccountResponse,
  CashManagementControllerCreateSimulationData,
  CashManagementControllerCreateSimulationResponse,
  CashManagementControllerDeleteSimulationData,
  CashManagementControllerUpdateSimulationData,
  CashManagementControllerUpdateSimulationResponse,
  CashManagementControllerApplySimulationData,
  CashManagementControllerGetAllProductsData,
  CashManagementControllerGetAllProductsResponse,
  CurrencyRateControllerGetAllTickersData,
  CurrencyRateControllerGetAllTickersResponse,
  CurrencyRateControllerGetTickerData,
  CurrencyRateControllerGetTickerResponse,
  LocalTestControllerGenerateDemoDealsData,
} from "./types.gen";
import { client as _heyApiClient } from "./client.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = ClientOptions<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Get API status
 */
export const appControllerPing = <ThrowOnError extends boolean = false>(
  options?: Options<AppControllerPingData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    url: "/ping",
    ...options,
  });
};

/**
 * Get all covenant types
 */
export const sharedControllerFindManyType = <ThrowOnError extends boolean = false>(
  options?: Options<SharedControllerFindManyTypeData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/enums/covenant_types",
    ...options,
  });
};

/**
 * Get all covenant details
 */
export const sharedControllerFindManyCovenantDetail = <ThrowOnError extends boolean = false>(
  options?: Options<SharedControllerFindManyCovenantDetailData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/enums/covenant_details",
    ...options,
  });
};

/**
 * Get all security types
 */
export const sharedControllerFindManyCovenantSecurityTypes = <ThrowOnError extends boolean = false>(
  options?: Options<SharedControllerFindManyCovenantSecurityTypesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/enums/security_types",
    ...options,
  });
};

/**
 * Login
 * Perform a sign in operation with optional MFA
 */
export const authControllerLogin = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerLoginData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<AuthControllerLoginResponse, unknown, ThrowOnError>(
    {
      url: "/auth/login",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Request new MFA code
 * Request a new MFA code for the user
 */
export const authControllerRequestMfa = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerRequestMfaData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    url: "/auth/request_mfa",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Request new PIN code
 * Request a new PIN code for the user
 */
export const authControllerRequestPin = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerRequestPinData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    url: "/auth/request_pin",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Confirm pin code is correct
 * Confirm pin code is correct
 */
export const authControllerSendPin = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerSendPinData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    url: "/auth/confirm_pin",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Signup [Deprecated]
 * Perform a sign-up request [Deprecated]
 */
export const authControllerSignup = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerSignupData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    url: "/auth/signup_request",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * New Signup request
 */
export const authControllerNewSignup = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerNewSignupData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    url: "/auth/new_signup_request",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Signup request [Local and Preprod only]
 */
export const authControllerSignupDemo = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerSignupDemoData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    url: "/auth/demo_signup",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Update email
 */
export const authControllerUpdateAccount = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerUpdateAccountData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/auth/update_account",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Activate user
 */
export const authControllerActivate = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerActivateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/auth/activate_user",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Change user account detail
 */
export const authControllerChangeRole = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerChangeRoleData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/auth/userAccount",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Confirm user with token
 */
export const authControllerConfirm = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerConfirmData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    AuthControllerConfirmResponse,
    unknown,
    ThrowOnError
  >({
    url: "/auth/confirm",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Refresh token
 */
export const authControllerRefresh = <ThrowOnError extends boolean = false>(
  options?: Options<AuthControllerRefreshData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    AuthControllerRefreshResponse,
    unknown,
    ThrowOnError
  >({
    url: "/auth/refresh_token",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Forgot password
 */
export const authControllerForgot = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerForgotData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    AuthControllerForgotResponse,
    unknown,
    ThrowOnError
  >({
    url: "/auth/forgot_password",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Reset password
 */
export const authControllerReset = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerResetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<AuthControllerResetResponse, unknown, ThrowOnError>(
    {
      url: "/auth/reset_password",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Logout
 */
export const authControllerLogout = <ThrowOnError extends boolean = false>(
  options?: Options<AuthControllerLogoutData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/auth/logout",
    ...options,
  });
};

/**
 * Get user context from token request
 */
export const authControllerRequestContext = <ThrowOnError extends boolean = false>(
  options: Options<AuthControllerRequestContextData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    url: "/auth/request_context",
    ...options,
  });
};

/**
 * Get all my reviews
 */
export const reviewControllerFindMyRequests = <ThrowOnError extends boolean = false>(
  options?: Options<ReviewControllerFindMyRequestsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ReviewControllerFindMyRequestsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/review",
    ...options,
  });
};

/**
 * Create a review
 */
export const reviewControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<ReviewControllerCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ReviewControllerCreateResponse,
    unknown,
    ThrowOnError
  >({
    url: "/review",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Cancel my review
 */
export const reviewControllerCancelRequest = <ThrowOnError extends boolean = false>(
  options: Options<ReviewControllerCancelRequestData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/review/{id}",
    ...options,
  });
};

/**
 * Find review by id
 */
export const reviewControllerFindById = <ThrowOnError extends boolean = false>(
  options: Options<ReviewControllerFindByIdData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/review/{id}",
    ...options,
  });
};

/**
 * Update a review
 */
export const reviewControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ReviewControllerUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    ReviewControllerUpdateResponse,
    unknown,
    ThrowOnError
  >({
    url: "/review/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Cancel a review [Agent only]
 */
export const reviewControllerCancelReview = <ThrowOnError extends boolean = false>(
  options: Options<ReviewControllerCancelReviewData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/review/{id}/cancel",
    ...options,
  });
};

/**
 * Save approver response
 */
export const reviewControllerVote = <ThrowOnError extends boolean = false>(
  options: Options<ReviewControllerVoteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<ReviewControllerVoteResponse, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/review/approval/{approvalId}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Find approval by token
 */
export const reviewControllerFindApprovalByToken = <ThrowOnError extends boolean = false>(
  options: Options<ReviewControllerFindApprovalByTokenData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    url: "/review/approval/token/{token}",
    ...options,
  });
};

/**
 * Save approver response by token
 */
export const reviewControllerVoteByToken = <ThrowOnError extends boolean = false>(
  options: Options<ReviewControllerVoteByTokenData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    ReviewControllerVoteByTokenResponse,
    unknown,
    ThrowOnError
  >({
    url: "/review/approval/token/{token}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get deal changes between dates
 */
export const reviewControllerFindMyChanges = <ThrowOnError extends boolean = false>(
  options: Options<ReviewControllerFindMyChangesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/review/changes",
    ...options,
  });
};

/**
 * Force the application of changes
 */
export const reviewControllerApplyChanges = <ThrowOnError extends boolean = false>(
  options: Options<ReviewControllerApplyChangesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ReviewControllerApplyChangesResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/review/apply/{id}",
    ...options,
  });
};

/**
 * Find approval by id
 */
export const reviewControllerFindApprovalById = <ThrowOnError extends boolean = false>(
  options: Options<ReviewControllerFindApprovalByIdData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/review/approval/{id}",
    ...options,
  });
};

/**
 * Find all reviews on my deals
 */
export const reviewControllerFindAllByGrantedDeals = <ThrowOnError extends boolean = false>(
  options?: Options<ReviewControllerFindAllByGrantedDealsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/review/grantedDeals",
    ...options,
  });
};

/**
 * Find my pending reviews
 */
export const reviewControllerFindPendingReviews = <ThrowOnError extends boolean = false>(
  options?: Options<ReviewControllerFindPendingReviewsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/review/findPendingReviews",
    ...options,
  });
};

/**
 * Find approval in progress by deal
 */
export const reviewControllerFindCurrentByDeal = <ThrowOnError extends boolean = false>(
  options: Options<ReviewControllerFindCurrentByDealData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ReviewControllerFindCurrentByDealResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/review/deal/{dealId}/current",
    ...options,
  });
};

/**
 * Find review in draft status
 */
export const reviewControllerGetDealReviewHistory = <ThrowOnError extends boolean = false>(
  options: Options<ReviewControllerGetDealReviewHistoryData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/review/deal/history/{dealId}",
    ...options,
  });
};

/**
 * Get all account events
 */
export const eventControllerFindMany = <ThrowOnError extends boolean = false>(
  options?: Options<EventControllerFindManyData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    EventControllerFindManyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/events",
    ...options,
  });
};

/**
 * Get all account corporate covenants and events merged
 */
export const eventControllerMerge = <ThrowOnError extends boolean = false>(
  options?: Options<EventControllerMergeData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    EventControllerMergeResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/events/calendar",
    ...options,
  });
};

/**
 * Update an event
 */
export const eventControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<EventControllerUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    EventControllerUpdateResponse,
    unknown,
    ThrowOnError
  >({
    url: "/events/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Update events by corporate
 */
export const eventControllerCompleteWithCorporate = <ThrowOnError extends boolean = false>(
  options: Options<EventControllerCompleteWithCorporateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    EventControllerCompleteWithCorporateResponse,
    unknown,
    ThrowOnError
  >({
    url: "/events/corporate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Send a reminder for an event
 */
export const eventControllerSendReminder = <ThrowOnError extends boolean = false>(
  options: Options<EventControllerSendReminderData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/events/{id}/reminder",
    ...options,
  });
};

/**
 * Get all corporate covenants
 */
export const corporateCovenantControllerFindMany = <ThrowOnError extends boolean = false>(
  options?: Options<CorporateCovenantControllerFindManyData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    CorporateCovenantControllerFindManyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/corporate_covenants",
    ...options,
  });
};

/**
 * Advanced - Get list of compliance Document per period
 */
export const corporateCovenantControllerGetComplianceDocuments = <
  ThrowOnError extends boolean = false,
>(
  options: Options<CorporateCovenantControllerGetComplianceDocumentsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    CorporateCovenantControllerGetComplianceDocumentsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/corporate_covenants/complianceDocuments",
    ...options,
  });
};

/**
 * Create values for a set of corporate covenants
 */
export const corporateCovenantControllerCreateValues = <ThrowOnError extends boolean = false>(
  options: Options<CorporateCovenantControllerCreateValuesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/corporate_covenants/{complianceDocument}/values",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get all compliance documents
 */
export const complianceDocumentControllerFindMany = <ThrowOnError extends boolean = false>(
  options?: Options<ComplianceDocumentControllerFindManyData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    ComplianceDocumentControllerFindManyResponse,
    unknown,
    ThrowOnError
  >({
    url: "/compliance_documents",
    ...options,
  });
};

/**
 * Get all loans of a deal
 */
export const loanControllerFindMany = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerFindManyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    LoanControllerFindManyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/deals/{dealId}/loans",
    ...options,
  });
};

/**
 * Create a loan or a tranche
 */
export const loanControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    LoanControllerCreateResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Remove a loan or a tranche
 */
export const loanControllerRemove = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerRemoveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
    url: "/deals/{dealId}/loans/{id}",
    ...options,
  });
};

/**
 * Update a loan or a tranche
 */
export const loanControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<LoanControllerUpdateResponse, unknown, ThrowOnError>(
    {
      url: "/deals/{dealId}/loans/{id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get all loans of a user
 */
export const loanControllerFindPortfolioDeals = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerFindPortfolioDealsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    LoanControllerFindPortfolioDealsResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/portfolio",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Split the loan into n tranches
 */
export const loanControllerCreateTranches = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerCreateTranchesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    LoanControllerCreateTranchesResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/{id}/tranches",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Set a banking syndicate to the loan
 */
export const loanControllerCreateBankingSyndicate = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerCreateBankingSyndicateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    LoanControllerCreateBankingSyndicateResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/{id}/banking_syndicates",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Remove a banking syndicate to the loan
 */
export const loanControllerRemoveBankingSyndicate = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerRemoveBankingSyndicateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
    url: "/deals/{dealId}/loans/{id}/banking_syndicates/{bankingSyndicateId}",
    ...options,
  });
};

/**
 * Update a banking syndicate to the loan
 */
export const loanControllerUpdateBankingSyndicate = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerUpdateBankingSyndicateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    LoanControllerUpdateBankingSyndicateResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/{id}/banking_syndicates/{bankingSyndicateId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Set a margin to the loan
 */
export const loanControllerCreateMargin = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerCreateMarginData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    LoanControllerCreateMarginResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/{id}/margins",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Remove a margin of the loan
 */
export const loanControllerRemoveMargin = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerRemoveMarginData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
    url: "/deals/{dealId}/loans/{id}/margins/{marginId}",
    ...options,
  });
};

/**
 * Update a margin of the loan
 */
export const loanControllerUpdateMargin = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerUpdateMarginData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    LoanControllerUpdateMarginResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/{id}/margins/{marginId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Set a drawndom to the loan
 */
export const loanControllerCreateDrawdown = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerCreateDrawdownData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    LoanControllerCreateDrawdownResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/{id}/drawdowns",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Remove a drawdown of the loan
 */
export const loanControllerDeleteDrawdown = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerDeleteDrawdownData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
    url: "/deals/{dealId}/loans/{id}/drawdowns/{drawdownId}",
    ...options,
  });
};

/**
 * Update a droawdown of the loan
 */
export const loanControllerUpdateDrawdown = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerUpdateDrawdownData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    LoanControllerUpdateDrawdownResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/{id}/drawdowns/{drawdownId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Remove all drawdowns of the loan
 */
export const loanControllerRemoveBulkDrawdown = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerRemoveBulkDrawdownData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
    url: "/deals/{dealId}/loans/{id}/drawdowns_bulk",
    ...options,
  });
};

/**
 * Set many drawdowns to the loan
 */
export const loanControllerCreateBulkDrawdown = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerCreateBulkDrawdownData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    LoanControllerCreateBulkDrawdownResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/{id}/drawdowns_bulk",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Set a repayment header to a loan
 */
export const loanControllerCreateRepaymentHeader = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerCreateRepaymentHeaderData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    LoanControllerCreateRepaymentHeaderResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/{id}/repayments",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Remove a repayment header of the loan
 */
export const loanControllerDeleteRepaymentHeader = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerDeleteRepaymentHeaderData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
    url: "/deals/{dealId}/loans/{id}/repayments/{headerId}",
    ...options,
  });
};

/**
 * Update a repayment header of the loan
 */
export const loanControllerUpdateRepaymentHeader = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerUpdateRepaymentHeaderData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    LoanControllerUpdateRepaymentHeaderResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/{id}/repayments/{headerId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Set a repayment schedule to a header
 */
export const loanControllerCreateRepaymentSchedule = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerCreateRepaymentScheduleData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    LoanControllerCreateRepaymentScheduleResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/{id}/repayments/{headerId}/schedules",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Remove all repayments schedule of the repayment header
 */
export const loanControllerRemoveBulkRepayment = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerRemoveBulkRepaymentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
    url: "/deals/{dealId}/loans/{id}/repayments/{headerId}/schedules_bulk",
    ...options,
  });
};

/**
 * Set many repayments schedule to a repayment header
 */
export const loanControllerCreateBulkRepayment = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerCreateBulkRepaymentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    LoanControllerCreateBulkRepaymentResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/{id}/repayments/{headerId}/schedules_bulk",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Set a security package to the loan
 */
export const loanControllerDuplicateSecurityPackage = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerDuplicateSecurityPackageData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    LoanControllerDuplicateSecurityPackageResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/{id}/security_packages/duplicate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Set a security package to the loan
 */
export const loanControllerCreateSecurityPackage = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerCreateSecurityPackageData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    LoanControllerCreateSecurityPackageResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/{id}/security_packages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Remove a security package of the loan
 */
export const loanControllerRemoveSecurityPackage = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerRemoveSecurityPackageData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
    url: "/deals/{dealId}/loans/{id}/security_packages/{securityPackageId}",
    ...options,
  });
};

/**
 * Update a security package
 */
export const loanControllerUpdateSecurityPackage = <ThrowOnError extends boolean = false>(
  options: Options<LoanControllerUpdateSecurityPackageData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    LoanControllerUpdateSecurityPackageResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/{id}/security_packages/{securityPackageId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Upsert margin based on covenant
 */
export const loanMarginControllerUpsertCovenant = <ThrowOnError extends boolean = false>(
  options: Options<LoanMarginControllerUpsertCovenantData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    url: "/deals/{dealId}/loans/{loanId}/margin/covenant",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Upsert margin based on rating
 */
export const loanMarginControllerUpsertRating = <ThrowOnError extends boolean = false>(
  options: Options<LoanMarginControllerUpsertRatingData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    url: "/deals/{dealId}/loans/{loanId}/margin/rating",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Upsert margin based on covenant
 */
export const loanMarginControllerAddCovenantValue = <ThrowOnError extends boolean = false>(
  options: Options<LoanMarginControllerAddCovenantValueData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    url: "/deals/{dealId}/loans/{loanId}/margin/covenant/value",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Upsert margin based on covenant
 */
export const loanMarginControllerUpdateCovenantValue = <ThrowOnError extends boolean = false>(
  options: Options<LoanMarginControllerUpdateCovenantValueData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    LoanMarginControllerUpdateCovenantValueResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/{loanId}/margin/covenant/value/{valueId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Upsert margin based on rating
 */
export const loanMarginControllerAddRatingValue = <ThrowOnError extends boolean = false>(
  options: Options<LoanMarginControllerAddRatingValueData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    url: "/deals/{dealId}/loans/{loanId}/margin/rating/value",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

export const eventLogControllerGetEventLogs = <ThrowOnError extends boolean = false>(
  options?: Options<EventLogControllerGetEventLogsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    EventLogControllerGetEventLogsResponse,
    unknown,
    ThrowOnError
  >({
    url: "/event-log",
    ...options,
  });
};

/**
 * Get all organizations by type
 */
export const organizationControllerFindMany = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationControllerFindManyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    OrganizationControllerFindManyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/organizations",
    ...options,
  });
};

/**
 * Create an organization
 */
export const organizationControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationControllerCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    OrganizationControllerCreateResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/organizations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get list of Borrowers
 */
export const organizationControllerFindBorrowers = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationControllerFindBorrowersData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    OrganizationControllerFindBorrowersResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/organizations/borrowers",
    ...options,
  });
};

/**
 * Create a new organization request
 */
export const organizationControllerCreateRequest = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationControllerCreateRequestData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    OrganizationControllerCreateRequestResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/organizations/create-request",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Join an organization
 */
export const organizationControllerJoin = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationControllerJoinData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/organizations/join/{id}",
    ...options,
  });
};

/**
 * Create bulk organizations
 */
export const organizationControllerCreateBulk = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationControllerCreateBulkData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    OrganizationControllerCreateBulkResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/organizations/_bulk",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Remove theme
 */
export const organizationControllerDeleteTheme = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationControllerDeleteThemeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/organizations/{id}/theme",
    ...options,
  });
};

/**
 * Configure organizaation theme
 */
export const organizationControllerChangeTheme = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationControllerChangeThemeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    OrganizationControllerChangeThemeResponse,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/organizations/{id}/theme",
    ...options,
    headers: {
      "Content-Type": null,
      ...options?.headers,
    },
  });
};

/**
 * Find file from S3
 */
export const organizationControllerGetDocumentS3 = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationControllerGetDocumentS3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/organizations/{id}/documents/file/{key}",
    ...options,
  });
};

/**
 * Provide corporate credit rating
 */
export const organizationControllerAddRating = <ThrowOnError extends boolean = false>(
  options: Options<OrganizationControllerAddRatingData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    OrganizationControllerAddRatingResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/organizations/{id}/rate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get all deals of an account
 */
export const dealControllerFindMany = <ThrowOnError extends boolean = false>(
  options?: Options<DealControllerFindManyData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    DealControllerFindManyResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals",
    ...options,
  });
};

/**
 * Create a deal
 */
export const dealControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    DealControllerCreateResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get AI API key for deals
 */
export const dealControllerGetAiApiKey = <ThrowOnError extends boolean = false>(
  options?: Options<DealControllerGetAiApiKeyData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    DealControllerGetAiApiKeyResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/ai_api_key",
    ...options,
  });
};

/**
 * Get all deals of an account
 */
export const dealControllerFindPortfolioDeals = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerFindPortfolioDealsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    DealControllerFindPortfolioDealsResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/portfolio",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get documents filter by date for event cron
 */
export const dealControllerFindDocumentByDate = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerFindDocumentByDateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    DealControllerFindDocumentByDateResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/documents",
    ...options,
  });
};

/**
 * Delete a deal
 */
export const dealControllerDelete = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerDeleteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DealControllerDeleteResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{id}",
    ...options,
  });
};

/**
 * Update a deal
 */
export const dealControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<DealControllerUpdateResponse, unknown, ThrowOnError>(
    {
      url: "/deals/{id}",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Validate a deal
 */
export const dealControllerValidate = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerValidateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    DealControllerValidateResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/deals/{id}/validate",
    ...options,
  });
};

/**
 * Set an agent or account banks to the deal
 */
export const dealControllerCreateAgentBankAccount = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerCreateAgentBankAccountData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    DealControllerCreateAgentBankAccountResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{id}/agent_account_banks",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Remove an agent or account bank to the deal
 */
export const dealControllerRemoveAgentAccountBank = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerRemoveAgentAccountBankData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
    url: "/deals/{id}/agent_account_banks/{agentAccountBankId}",
    ...options,
  });
};

/**
 * Update an agent or account bank to the deal
 */
export const dealControllerUpdateAgentBankAccount = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerUpdateAgentBankAccountData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    DealControllerUpdateAgentBankAccountResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{id}/agent_account_banks/{agentAccountBankId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get all documents from the deal
 */
export const dealControllerFindManyDocument = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerFindManyDocumentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    DealControllerFindManyDocumentResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/deals/{id}/documents",
    ...options,
  });
};

/**
 * Set a document to the deal
 */
export const dealControllerCreateDocument = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerCreateDocumentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/deals/{id}/documents",
    ...options,
    headers: {
      "Content-Type": null,
      ...options?.headers,
    },
  });
};

/**
 * Update signed  document of the deal
 */
export const dealControllerUpdateSignedDocument = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerUpdateSignedDocumentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    DealControllerUpdateSignedDocumentResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{id}/documents/sign/{signatureKey}",
    ...options,
  });
};

/**
 * Update signed  document of the deal
 */
export const dealControllerGetDocumentPdf = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerGetDocumentPdfData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/deals/{id}/documents/signed/{envelopeId}",
    ...options,
  });
};

/**
 * Find file from S3
 */
export const dealControllerGetDocumentS3 = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerGetDocumentS3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/deals/{id}/documents/file/{documentId}",
    ...options,
  });
};

/**
 * Delete a document from the deal
 */
export const dealControllerRemoveDocument = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerRemoveDocumentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/deals/{id}/documents/{documentId}",
    ...options,
  });
};

/**
 * Get a document from the deal
 */
export const dealControllerGetDocument = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerGetDocumentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/deals/{id}/documents/{documentId}",
    ...options,
  });
};

/**
 * Update a document of the deal
 */
export const dealControllerUpdateDocument = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerUpdateDocumentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/deals/{id}/documents/{documentId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get all documents from the deal
 */
export const dealControllerFindOnlyDealDocument = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerFindOnlyDealDocumentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    DealControllerFindOnlyDealDocumentResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/deals/{id}/documents/onlydeal",
    ...options,
  });
};

/**
 * Get contacts of a deal
 */
export const dealControllerFindManyContacts = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerFindManyContactsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/deals/{id}/contacts",
    ...options,
  });
};

/**
 * Invite contact on a deal
 */
export const dealControllerInvite = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerInviteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    DealControllerInviteResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{id}/contacts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Invite group of contacts
 */
export const dealControllerCreateBulkContact = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerCreateBulkContactData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    DealControllerCreateBulkContactResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{id}/group",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Find contacts by email
 */
export const dealControllerFindContacts = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerFindContactsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/deals/{id}/contacts/find",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get organizations of a deal
 */
export const dealControllerFindManyOrganizations = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerFindManyOrganizationsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    DealControllerFindManyOrganizationsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/deals/{id}/organizations",
    ...options,
  });
};

/**
 * Remove a contact from a deal
 */
export const dealControllerRemoveContact = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerRemoveContactData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
    url: "/deals/{id}/contacts/{contactId}",
    ...options,
  });
};

/**
 * Update a contact on a deal
 */
export const dealControllerUpdateContact = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerUpdateContactData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    DealControllerUpdateContactResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{id}/contacts/{contactId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Update a contact on a deal
 */
export const dealControllerDeleteMainContact = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerDeleteMainContactData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    DealControllerDeleteMainContactResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{id}/main_contacts/{contactId}",
    ...options,
  });
};

/**
 * Update a contact on a deal
 */
export const dealControllerUpdateMainContact = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerUpdateMainContactData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    DealControllerUpdateMainContactResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{id}/main_contacts/{contactId}",
    ...options,
  });
};

/**
 * Get conversation with a contact on a deal
 */
export const dealControllerFindManyMessage = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerFindManyMessageData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/deals/{id}/contacts/{contactId}/messages",
    ...options,
  });
};

/**
 * Send a message to a contact on a deal
 */
export const dealControllerCreateMessage = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerCreateMessageData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    DealControllerCreateMessageResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/deals/{id}/contacts/{contactId}/messages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Notify the api when a message is read
 */
export const dealControllerReadMessage = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerReadMessageData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    DealControllerReadMessageResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/deals/messages/{messageId}",
    ...options,
  });
};

/**
 * List the values ​​by deal id and by covenant id
 */
export const dealControllerFindCovenantValues = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerFindCovenantValuesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    DealControllerFindCovenantValuesResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/deals/{id}/covenants/values",
    ...options,
  });
};

/**
 * Post digest and get deal hash
 */
export const dealControllerGethash = <ThrowOnError extends boolean = false>(
  options: Options<DealControllerGethashData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    DealControllerGethashResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/deals/{id}/hash",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get securities with asset and asset ratio covenant for a deal
 */
export const dealSecuritiesControllerFind = <ThrowOnError extends boolean = false>(
  options: Options<DealSecuritiesControllerFindData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    DealSecuritiesControllerFindResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/deals/{dealId}/deals_securities",
    ...options,
  });
};

/**
 * Set a document to the deal
 */
export const parseDocumentsControllerCreateDocument = <ThrowOnError extends boolean = false>(
  options: Options<ParseDocumentsControllerCreateDocumentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    ParseDocumentsControllerCreateDocumentResponse,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/deal/parse/term",
    ...options,
    headers: {
      "Content-Type": null,
      ...options?.headers,
    },
  });
};

/**
 * Find file from S3
 */
export const parseDocumentsControllerGetDocumentS3 = <ThrowOnError extends boolean = false>(
  options: Options<ParseDocumentsControllerGetDocumentS3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/deal/parse/file",
    ...options,
  });
};

/**
 * Retrieve the document tree for a given deal
 */
export const documentTreeControllerGetDocumentTree = <ThrowOnError extends boolean = false>(
  options: Options<DocumentTreeControllerGetDocumentTreeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    DocumentTreeControllerGetDocumentTreeResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/document-tree",
    ...options,
  });
};

/**
 * Create or update the document tree for a given deal
 */
export const documentTreeControllerUpsertDocumentTree = <ThrowOnError extends boolean = false>(
  options: Options<DocumentTreeControllerUpsertDocumentTreeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    url: "/deals/{dealId}/document-tree",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get all my templates
 */
export const templateControllerFindMany = <ThrowOnError extends boolean = false>(
  options?: Options<TemplateControllerFindManyData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/templates",
    ...options,
  });
};

/**
 * Create a new template
 */
export const templateControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<TemplateControllerCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    url: "/templates",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get a template by Id
 */
export const templateControllerFindTemplateById = <ThrowOnError extends boolean = false>(
  options: Options<TemplateControllerFindTemplateByIdData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/templates/{id}",
    ...options,
  });
};

/**
 * Update a template
 */
export const templateControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TemplateControllerUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    TemplateControllerUpdateResponse,
    unknown,
    ThrowOnError
  >({
    url: "/templates/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get all templates of a deal
 */
export const templateControllerFindTemplate = <ThrowOnError extends boolean = false>(
  options: Options<TemplateControllerFindTemplateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/templates/{dealId}/{context}",
    ...options,
  });
};

/**
 * Get all covenants of a loan
 */
export const covenantControllerFindMany = <ThrowOnError extends boolean = false>(
  options: Options<CovenantControllerFindManyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    CovenantControllerFindManyResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/{loanId}/covenants",
    ...options,
  });
};

/**
 * Create a covenant
 */
export const covenantControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<CovenantControllerCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CovenantControllerCreateResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/{loanId}/covenants",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Remove a covenant
 */
export const covenantControllerRemove = <ThrowOnError extends boolean = false>(
  options: Options<CovenantControllerRemoveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    CovenantControllerRemoveResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/{loanId}/covenants/{id}",
    ...options,
  });
};

/**
 * Update a covenant
 */
export const covenantControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CovenantControllerUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    CovenantControllerUpdateResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/{loanId}/covenants/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Set a threshold to the convenant
 */
export const covenantControllerCreateThreshold = <ThrowOnError extends boolean = false>(
  options: Options<CovenantControllerCreateThresholdData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CovenantControllerCreateThresholdResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/{loanId}/covenants/{id}/thresholds",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Remove a threshold to the convenant
 */
export const covenantControllerRemoveThreshold = <ThrowOnError extends boolean = false>(
  options: Options<CovenantControllerRemoveThresholdData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    CovenantControllerRemoveThresholdResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/{loanId}/covenants/{id}/thresholds/{thresholdId}",
    ...options,
  });
};

/**
 * Set a threshold to the convenant
 */
export const covenantControllerUpdateThreshold = <ThrowOnError extends boolean = false>(
  options: Options<CovenantControllerUpdateThresholdData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    CovenantControllerUpdateThresholdResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/{loanId}/covenants/{id}/thresholds/{thresholdId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Set a value to the convenant
 */
export const covenantControllerCreateValues = <ThrowOnError extends boolean = false>(
  options: Options<CovenantControllerCreateValuesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CovenantControllerCreateValuesResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/loans/{loanId}/covenants/{id}/values",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get all compliance certificates of a deal
 */
export const certificateControllerFindMany = <ThrowOnError extends boolean = false>(
  options: Options<CertificateControllerFindManyData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    CertificateControllerFindManyResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/compliance_certificates",
    ...options,
  });
};

/**
 * Create a compliance certificate
 */
export const certificateControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<CertificateControllerCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CertificateControllerCreateResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/deals/{dealId}/compliance_certificates",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Remove a compliance certificate
 */
export const certificateControllerRemove = <ThrowOnError extends boolean = false>(
  options: Options<CertificateControllerRemoveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    CertificateControllerRemoveResponse,
    unknown,
    ThrowOnError
  >({
    url: "/deals/{dealId}/compliance_certificates/{id}",
    ...options,
  });
};

/**
 * Update a compliance certificate
 */
export const certificateControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CertificateControllerUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    CertificateControllerUpdateResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/deals/{dealId}/compliance_certificates/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get all currencies
 */
export const currencyControllerFindMany = <ThrowOnError extends boolean = false>(
  options?: Options<CurrencyControllerFindManyData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    CurrencyControllerFindManyResponse,
    unknown,
    ThrowOnError
  >({
    url: "/currencies",
    ...options,
  });
};

/**
 * Create a currency
 */
export const currencyControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<CurrencyControllerCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CurrencyControllerCreateResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/currencies",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get user data
 */
export const userControllerMe = <ThrowOnError extends boolean = false>(
  options?: Options<UserControllerMeData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<UserControllerMeResponse, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/me",
    ...options,
  });
};

/**
 * Update user data
 */
export const userControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<UserControllerUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<UserControllerUpdateResponse, unknown, ThrowOnError>(
    {
      security: [
        {
          scheme: "bearer",
          type: "http",
        },
      ],
      url: "/me",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Get portfolio information
 */
export const userControllerPortfolio = <ThrowOnError extends boolean = false>(
  options?: Options<UserControllerPortfolioData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    UserControllerPortfolioResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/me/portfolio",
    ...options,
  });
};

/**
 * Get accounts
 */
export const userControllerGetAccounts = <ThrowOnError extends boolean = false>(
  options?: Options<UserControllerGetAccountsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    UserControllerGetAccountsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/me/accounts",
    ...options,
  });
};

/**
 * Get user data by token
 */
export const userControllerByToken = <ThrowOnError extends boolean = false>(
  options: Options<UserControllerByTokenData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    UserControllerByTokenResponse,
    unknown,
    ThrowOnError
  >({
    url: "/me/find/{token}",
    ...options,
  });
};

/**
 * Get user data
 */
export const userControllerReadNotification = <ThrowOnError extends boolean = false>(
  options: Options<UserControllerReadNotificationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    UserControllerReadNotificationResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/me/notification/read/{id}",
    ...options,
  });
};

/**
 * Mark all type of notification read
 */
export const userControllerReadAllNotification = <ThrowOnError extends boolean = false>(
  options: Options<UserControllerReadAllNotificationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    UserControllerReadAllNotificationResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/me/notification/readAll/{type}",
    ...options,
  });
};

/**
 * Mark all type of notification read
 */
export const userControllerReadAlChatMessages = <ThrowOnError extends boolean = false>(
  options?: Options<UserControllerReadAlChatMessagesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    UserControllerReadAlChatMessagesResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/me/notification/readAllChatMessages",
    ...options,
  });
};

/**
 * Update user status
 */
export const userControllerStatusUpdate = <ThrowOnError extends boolean = false>(
  options: Options<UserControllerStatusUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    UserControllerStatusUpdateResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/me/status",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get user notes
 */
export const userControllerNotes = <ThrowOnError extends boolean = false>(
  options?: Options<UserControllerNotesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/me/notes",
    ...options,
  });
};

/**
 * Create user note
 */
export const userControllerCreateNote = <ThrowOnError extends boolean = false>(
  options: Options<UserControllerCreateNoteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    UserControllerCreateNoteResponse,
    unknown,
    ThrowOnError
  >({
    url: "/me/notes",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Remove user note
 */
export const userControllerRemoveNote = <ThrowOnError extends boolean = false>(
  options: Options<UserControllerRemoveNoteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/me/notes/{id}",
    ...options,
  });
};

/**
 * Update user note
 */
export const userControllerUpdateNote = <ThrowOnError extends boolean = false>(
  options: Options<UserControllerUpdateNoteData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/me/notes/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Update my preferences
 */
export const userControllerMyPreferences = <ThrowOnError extends boolean = false>(
  options?: Options<UserControllerMyPreferencesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/me/preferences",
    ...options,
  });
};

/**
 * Update my preferences
 */
export const userControllerPreferences = <ThrowOnError extends boolean = false>(
  options: Options<UserControllerPreferencesData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/me/preferences",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get ACL
 */
export const userControllerFindAcl = <ThrowOnError extends boolean = false>(
  options?: Options<UserControllerFindAclData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    url: "/me/acl",
    ...options,
  });
};

/**
 * Get user new messages
 */
export const sseControllerMessages = <ThrowOnError extends boolean = false>(
  options?: Options<SseControllerMessagesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    SseControllerMessagesResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/sse/messages",
    ...options,
  });
};

/**
 * Get user new notifications
 */
export const sseControllerNotifications = <ThrowOnError extends boolean = false>(
  options?: Options<SseControllerNotificationsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    SseControllerNotificationsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/sse/notifications",
    ...options,
  });
};

/**
 * Get user new notifications
 */
export const sseControllerConnectedContacts = <ThrowOnError extends boolean = false>(
  options?: Options<SseControllerConnectedContactsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/sse/connectedContacts",
    ...options,
  });
};

/**
 * Add new assets
 */
export const assetControllerCreateAssets = <ThrowOnError extends boolean = false>(
  options: Options<AssetControllerCreateAssetsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    url: "/asset",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Add asset market value
 */
export const assetControllerCreateAssetValue = <ThrowOnError extends boolean = false>(
  options: Options<AssetControllerCreateAssetValueData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    url: "/asset/{id}/value",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Add asset employment
 */
export const assetControllerCreateAssetEmployment = <ThrowOnError extends boolean = false>(
  options: Options<AssetControllerCreateAssetEmploymentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    url: "/asset/{id}/employment",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Add asset insurance
 */
export const assetControllerCreateAssetInsurance = <ThrowOnError extends boolean = false>(
  options: Options<AssetControllerCreateAssetInsuranceData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    url: "/asset/{id}/insurance",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Add asset insurance
 */
export const assetControllerCreateEsgValue = <ThrowOnError extends boolean = false>(
  options: Options<AssetControllerCreateEsgValueData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    url: "/asset/{id}/ESG",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Delete one asset
 */
export const assetControllerDeleteAssetValue = <ThrowOnError extends boolean = false>(
  options: Options<AssetControllerDeleteAssetValueData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
    url: "/asset/{id}/value/{valueId}",
    ...options,
  });
};

/**
 * Add new assets
 */
export const assetControllerUpdateAssetValue = <ThrowOnError extends boolean = false>(
  options: Options<AssetControllerUpdateAssetValueData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    AssetControllerUpdateAssetValueResponse,
    unknown,
    ThrowOnError
  >({
    url: "/asset/{id}/value/{valueId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Delete asset employment
 */
export const assetControllerDeleteAssetEmployment = <ThrowOnError extends boolean = false>(
  options: Options<AssetControllerDeleteAssetEmploymentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
    url: "/asset/{id}/employment/{employmentId}",
    ...options,
  });
};

/**
 * Update employment
 */
export const assetControllerUpdateEmploymentValue = <ThrowOnError extends boolean = false>(
  options: Options<AssetControllerUpdateEmploymentValueData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    AssetControllerUpdateEmploymentValueResponse,
    unknown,
    ThrowOnError
  >({
    url: "/asset/{id}/employment/{employmentId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Activate employment
 */
export const assetControllerActivateEmployment = <ThrowOnError extends boolean = false>(
  options: Options<AssetControllerActivateEmploymentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    AssetControllerActivateEmploymentResponse,
    unknown,
    ThrowOnError
  >({
    url: "/asset/{id}/employment/{employmentId}/activate",
    ...options,
  });
};

/**
 * Delete asset insurance
 */
export const assetControllerDeleteAssetInsurance = <ThrowOnError extends boolean = false>(
  options: Options<AssetControllerDeleteAssetInsuranceData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
    url: "/asset/{id}/insurance/{insuranceId}",
    ...options,
  });
};

/**
 * Update insurance
 */
export const assetControllerUpdateInsuranceValue = <ThrowOnError extends boolean = false>(
  options: Options<AssetControllerUpdateInsuranceValueData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    AssetControllerUpdateInsuranceValueResponse,
    unknown,
    ThrowOnError
  >({
    url: "/asset/{id}/insurance/{insuranceId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Delete one asset
 */
export const assetControllerDeleteAsset = <ThrowOnError extends boolean = false>(
  options: Options<AssetControllerDeleteAssetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
    url: "/asset/{id}",
    ...options,
  });
};

/**
 * Find one asset and it s values
 */
export const assetControllerGetAsset = <ThrowOnError extends boolean = false>(
  options: Options<AssetControllerGetAssetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    url: "/asset/{id}",
    ...options,
  });
};

/**
 * Update an assets
 */
export const assetControllerUpdateAsset = <ThrowOnError extends boolean = false>(
  options: Options<AssetControllerUpdateAssetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    AssetControllerUpdateAssetResponse,
    unknown,
    ThrowOnError
  >({
    url: "/asset/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Delete asset ESG value
 */
export const assetControllerDeleteAssetEsgValue = <ThrowOnError extends boolean = false>(
  options: Options<AssetControllerDeleteAssetEsgValueData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
    url: "/asset/{id}/ESGValue/{ESGValueId}",
    ...options,
  });
};

/**
 * Delete asset CII Forecast
 */
export const assetControllerDeleteCiiForecast = <ThrowOnError extends boolean = false>(
  options: Options<AssetControllerDeleteCiiForecastData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
    url: "/asset/{id}/CIIForecast/{CIIForecastId}",
    ...options,
  });
};

/**
 * Find assets of a deal
 */
export const assetControllerFind = <ThrowOnError extends boolean = false>(
  options: Options<AssetControllerFindData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<AssetControllerFindResponse, unknown, ThrowOnError>(
    {
      url: "/asset/find",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...options?.headers,
      },
    }
  );
};

/**
 * Find assets of the loans
 */
export const assetControllerLoanAssetFind = <ThrowOnError extends boolean = false>(
  options?: Options<AssetControllerLoanAssetFindData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    AssetControllerLoanAssetFindResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/asset/loanAssets",
    ...options,
  });
};

/**
 * Find assets and all its values
 */
export const assetControllerFindAssetValues = <ThrowOnError extends boolean = false>(
  options?: Options<AssetControllerFindAssetValuesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    AssetControllerFindAssetValuesResponse,
    unknown,
    ThrowOnError
  >({
    url: "/asset/findAssetValues",
    ...options,
  });
};

/**
 * Delete payment schedule
 */
export const leasingControllerDeleteAssetSchedule = <ThrowOnError extends boolean = false>(
  options: Options<LeasingControllerDeleteAssetScheduleData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    LeasingControllerDeleteAssetScheduleResponse,
    unknown,
    ThrowOnError
  >({
    url: "/leasing/{id}",
    ...options,
  });
};

/**
 * Find leasing by asset id
 */
export const leasingControllerFindAssetSchedule = <ThrowOnError extends boolean = false>(
  options: Options<LeasingControllerFindAssetScheduleData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    url: "/leasing/{id}",
    ...options,
  });
};

/**
 * Create payment schedule
 */
export const leasingControllerCreateAssetSchedule = <ThrowOnError extends boolean = false>(
  options: Options<LeasingControllerCreateAssetScheduleData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    url: "/leasing/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Update payment schedule
 */
export const leasingControllerUpdateAssetSchedule = <ThrowOnError extends boolean = false>(
  options: Options<LeasingControllerUpdateAssetScheduleData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    LeasingControllerUpdateAssetScheduleResponse,
    unknown,
    ThrowOnError
  >({
    url: "/leasing/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Update schedule instalment
 */
export const leasingControllerUpdateInstalment = <ThrowOnError extends boolean = false>(
  options: Options<LeasingControllerUpdateInstalmentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    LeasingControllerUpdateInstalmentResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/leasing/{id}/{instalmentId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Send a reminder for a payment
 */
export const leasingControllerSendReminder = <ThrowOnError extends boolean = false>(
  options: Options<LeasingControllerSendReminderData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/leasing/{id}/{instalmentId}/reminder",
    ...options,
  });
};

/**
 * Find one country
 */
export const countryControllerGetCountry = <ThrowOnError extends boolean = false>(
  options: Options<CountryControllerGetCountryData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    url: "/country/{ISO2}",
    ...options,
  });
};

/**
 * Find all countries without details
 */
export const countryControllerFind = <ThrowOnError extends boolean = false>(
  options?: Options<CountryControllerFindData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    url: "/country",
    ...options,
  });
};

/**
 * Set a document to the deal
 */
export const docusignControllerCreateDocument = <ThrowOnError extends boolean = false>(
  options: Options<DocusignControllerCreateDocumentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    DocusignControllerCreateDocumentResponse,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/docusign/deal/{id}",
    ...options,
    headers: {
      "Content-Type": null,
      ...options?.headers,
    },
  });
};

/**
 * Settings required for Docusign integration
 */
export const docusignControllerPing = <ThrowOnError extends boolean = false>(
  options?: Options<DocusignControllerPingData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).post<
    DocusignControllerPingResponse,
    unknown,
    ThrowOnError
  >({
    url: "/docusign/ping/{key}",
    ...options,
  });
};

/**
 * Get all document types
 */
export const corporateDocumentControllerFindTypes = <ThrowOnError extends boolean = false>(
  options?: Options<CorporateDocumentControllerFindTypesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    CorporateDocumentControllerFindTypesResponse,
    unknown,
    ThrowOnError
  >({
    url: "/corporate_documents/types",
    ...options,
  });
};

/**
 * Post new corporate document
 */
export const corporateDocumentControllerCreateDocument = <ThrowOnError extends boolean = false>(
  options: Options<CorporateDocumentControllerCreateDocumentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CorporateDocumentControllerCreateDocumentResponse,
    unknown,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    url: "/corporate_documents/file",
    ...options,
    headers: {
      "Content-Type": null,
      ...options?.headers,
    },
  });
};

/**
 * Delete a document
 */
export const corporateDocumentControllerDeleteDocument = <ThrowOnError extends boolean = false>(
  options: Options<CorporateDocumentControllerDeleteDocumentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<
    CorporateDocumentControllerDeleteDocumentResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/corporate_documents/{id}",
    ...options,
  });
};

/**
 * Update a document
 */
export const corporateDocumentControllerUpdateDocument = <ThrowOnError extends boolean = false>(
  options: Options<CorporateDocumentControllerUpdateDocumentData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<
    CorporateDocumentControllerUpdateDocumentResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/corporate_documents/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Find file from S3
 */
export const corporateDocumentControllerGetDocumentS3 = <ThrowOnError extends boolean = false>(
  options: Options<CorporateDocumentControllerGetDocumentS3Data, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/corporate_documents/file/{documentId}",
    ...options,
  });
};

/**
 * Find corporates
 */
export const corporateDocumentControllerGetCorporates = <ThrowOnError extends boolean = false>(
  options?: Options<CorporateDocumentControllerGetCorporatesData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/corporate_documents",
    ...options,
  });
};

/**
 * Compute OhDear checks
 */
export const healthControllerComputeOhDearSummary = <ThrowOnError extends boolean = false>(
  options?: Options<HealthControllerComputeOhDearSummaryData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    HealthControllerComputeOhDearSummaryResponse,
    unknown,
    ThrowOnError
  >({
    url: "/health/oh-dear",
    ...options,
  });
};

/**
 * Compute Prometheus exports
 */
export const exporterControllerComputeExport = <ThrowOnError extends boolean = false>(
  options: Options<ExporterControllerComputeExportData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    ExporterControllerComputeExportResponse,
    unknown,
    ThrowOnError
  >({
    url: "/metrics",
    ...options,
  });
};

/**
 * Create CII forecast
 */
export const ciiControllerProccess = <ThrowOnError extends boolean = false>(
  options: Options<CiiControllerProccessData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    url: "/cii",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get a CII forecast
 */
export const ciiControllerFind = <ThrowOnError extends boolean = false>(
  options: Options<CiiControllerFindData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<CiiControllerFindResponse, unknown, ThrowOnError>({
    url: "/cii/{id}",
    ...options,
  });
};

/**
 * Save CII forecast
 */
export const ciiControllerSave = <ThrowOnError extends boolean = false>(
  options: Options<CiiControllerSaveData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    url: "/cii/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Update CII forecast
 */
export const ciiControllerUpdate = <ThrowOnError extends boolean = false>(
  options: Options<CiiControllerUpdateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<CiiControllerUpdateResponse, unknown, ThrowOnError>({
    url: "/cii/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get CII forecast for an asset
 */
export const ciiControllerFindByAsset = <ThrowOnError extends boolean = false>(
  options: Options<CiiControllerFindByAssetData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    CiiControllerFindByAssetResponse,
    unknown,
    ThrowOnError
  >({
    url: "/cii/findByAsset/{assetId}",
    ...options,
  });
};

/**
 * Get all accounts
 */
export const accountControllerFindMany = <ThrowOnError extends boolean = false>(
  options?: Options<AccountControllerFindManyData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    AccountControllerFindManyResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/accounts",
    ...options,
  });
};

/**
 * Create an Account
 */
export const accountControllerCreate = <ThrowOnError extends boolean = false>(
  options: Options<AccountControllerCreateData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    AccountControllerCreateResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/accounts",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Add user to account
 */
export const accountControllerAddUserToaccount = <ThrowOnError extends boolean = false>(
  options: Options<AccountControllerAddUserToaccountData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).put<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/accounts/user",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get all active trades for the current account
 */
export const cashManagementControllerGetAllTradesByAccount = <ThrowOnError extends boolean = false>(
  options?: Options<CashManagementControllerGetAllTradesByAccountData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    CashManagementControllerGetAllTradesByAccountResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/cash-management/trades",
    ...options,
  });
};

/**
 * Create a new trade
 */
export const cashManagementControllerUpsertTrade = <ThrowOnError extends boolean = false>(
  options: Options<CashManagementControllerUpsertTradeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CashManagementControllerUpsertTradeResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/cash-management/trades",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Delete a trade
 */
export const cashManagementControllerDeleteTrade = <ThrowOnError extends boolean = false>(
  options: Options<CashManagementControllerDeleteTradeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/cash-management/trades/{id}",
    ...options,
  });
};

/**
 * Update a trade
 */
export const cashManagementControllerUpdateTrade = <ThrowOnError extends boolean = false>(
  options: Options<CashManagementControllerUpdateTradeData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    CashManagementControllerUpdateTradeResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/cash-management/trades/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Get all simulations for the current account
 */
export const cashManagementControllerFindSimlationsByAccount = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<CashManagementControllerFindSimlationsByAccountData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    CashManagementControllerFindSimlationsByAccountResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/cash-management/simulations",
    ...options,
  });
};

/**
 * Create a new simulation
 */
export const cashManagementControllerCreateSimulation = <ThrowOnError extends boolean = false>(
  options: Options<CashManagementControllerCreateSimulationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<
    CashManagementControllerCreateSimulationResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/cash-management/simulations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Delete a simulation
 */
export const cashManagementControllerDeleteSimulation = <ThrowOnError extends boolean = false>(
  options: Options<CashManagementControllerDeleteSimulationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).delete<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/cash-management/simulations/{id}",
    ...options,
  });
};

/**
 * Update a simulation
 */
export const cashManagementControllerUpdateSimulation = <ThrowOnError extends boolean = false>(
  options: Options<CashManagementControllerUpdateSimulationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).patch<
    CashManagementControllerUpdateSimulationResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/cash-management/simulations/{id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options?.headers,
    },
  });
};

/**
 * Apply a simulation
 */
export const cashManagementControllerApplySimulation = <ThrowOnError extends boolean = false>(
  options: Options<CashManagementControllerApplySimulationData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/cash-management/simulations/{id}/apply",
    ...options,
  });
};

/**
 * Get all products
 */
export const cashManagementControllerGetAllProducts = <ThrowOnError extends boolean = false>(
  options?: Options<CashManagementControllerGetAllProductsData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    CashManagementControllerGetAllProductsResponse,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/cash-management/products",
    ...options,
  });
};

export const currencyRateControllerGetAllTickers = <ThrowOnError extends boolean = false>(
  options?: Options<CurrencyRateControllerGetAllTickersData, ThrowOnError>
) => {
  return (options?.client ?? _heyApiClient).get<
    CurrencyRateControllerGetAllTickersResponse,
    unknown,
    ThrowOnError
  >({
    url: "/currency_rates/all",
    ...options,
  });
};

export const currencyRateControllerGetTicker = <ThrowOnError extends boolean = false>(
  options: Options<CurrencyRateControllerGetTickerData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).get<
    CurrencyRateControllerGetTickerResponse,
    unknown,
    ThrowOnError
  >({
    url: "/currency_rates/{symbol}",
    ...options,
  });
};

/**
 * Generate demo deals
 */
export const localTestControllerGenerateDemoDeals = <ThrowOnError extends boolean = false>(
  options: Options<LocalTestControllerGenerateDemoDealsData, ThrowOnError>
) => {
  return (options.client ?? _heyApiClient).post<unknown, unknown, ThrowOnError>({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/local_tests/generateDemoDeals",
    ...options,
  });
};
